// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"23":"3af6ef42","201":"87adcf82","361":"0f3f46c0","981":"3c4cf595"}[chunkId] + ".js";
};